import FreeMembershipCard from './FreeMembershipCard'

export default FreeMembershipCard
